/* Sorti de la page le 19 aout 2026 : ce code est le meme pour toutes les
   pages, donc il appartient a un fichier que le navigateur garde en cache,
   pas au HTML qui est retelecharge a chaque visite.

   La garde ci-dessous existe parce qu'un fichier charge deux fois s'execute
   deux fois, ce qui doublerait les ecouteurs. */
if (!window.__fvHeaderJs) {
  window.__fvHeaderJs = true;
(function () {
  var hdr = document.getElementById('fv-header');
  if (!hdr) return;
  var tickerH = 36;
  var lastY = Math.max(0, window.scrollY);
  var ticking = false;

  /* ── Pourquoi ce code est plus long que « if (y > lastY) cacher » ──
     Sur Safari iOS, trois choses faussent la lecture de la direction du
     scroll, et le header se cachait tout seul en remontant :

     1. Le rebond elastique. En haut de page scrollY passe SOUS zero, en bas
        il depasse la hauteur reelle. Au retour du rebond la valeur remonte,
        ce qui imite un scroll vers le bas alors que le doigt va vers le haut.
     2. La barre d'adresse qui se replie declenche un evenement de scroll
        sans que rien n'ait bouge, le header basculait a chaque repli.
     3. L'inertie produit des variations d'un pixel : sans seuil, la classe
        bascule des dizaines de fois par seconde et le header clignote.

     Chrome Android n'a aucun de ces trois comportements, d'ou un bug
     invisible en test sur Chrome. */

  var muteUntil = 0;
  if (window.visualViewport) {
    /* Le redimensionnement du viewport visuel est la signature du repli de la
       barre d'adresse. On se tait 350 ms, le temps de son animation. */
    window.visualViewport.addEventListener('resize', function () {
      muteUntil = Date.now() + 350;
    });
  }

  function apply() {
    ticking = false;

    /* Bornage : neutralise le rebond elastique (cause 1). */
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var y = Math.min(Math.max(0, window.scrollY), max);

    hdr.classList.toggle('fv-header--scrolled', y > tickerH + 20);

    // mobile uniquement : masquer en descendant, révéler en remontant
    var isMobile = window.matchMedia('(max-width: 899px)').matches;
    var menuOpen = document.body.classList.contains('fv-menu-open');
    // La ligne de recherche vit DANS le header : le masquer au scroll ferait
    // disparaitre le champ pendant que le client y tape. Le clavier mobile
    // provoque justement un evenement de scroll a l'ouverture.
    var searchOpen = document.body.classList.contains('fv-search-open');

    if (!isMobile || menuOpen || searchOpen) {
      hdr.classList.remove('fv-header--hidden');
      lastY = y;
      return;
    }

    /* Cause 2 : on ignore la periode d'animation de la barre d'adresse. */
    if (Date.now() < muteUntil) { lastY = y; return; }

    /* Pres du haut, le header est toujours visible : c'est la regle la plus
       forte, elle passe avant le seuil. */
    if (y <= 120) {
      hdr.classList.remove('fv-header--hidden');
      lastY = y;
      return;
    }

    /* Cause 3 : sous 8 px c'est du tremblement, pas une intention. On ne
       met PAS lastY a jour, pour que les petits deplacements s'additionnent
       jusqu'a former un vrai geste. */
    var d = y - lastY;
    if (Math.abs(d) < 8) return;

    if (d > 0) {
      hdr.classList.add('fv-header--hidden');
    } else {
      hdr.classList.remove('fv-header--hidden');
    }
    lastY = y;
  }

  /* Une seule lecture par image : sur iOS l'evenement scroll part beaucoup
     plus souvent que le rafraichissement de l'ecran. */
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var menuBtn = hdr.querySelector('.fv-h-menu');
  var drop = document.getElementById('fv-menu-drop');
  // Sortir le tiroir du header : imbriqué dans .fv-header (contexte d'empilement), il se
  // faisait recouvrir par les photos produit à transform (.fv-ugc-item) promues en couches
  // de composition. Comme enfant direct de <body>, son z-index s'applique au niveau racine
  // et passe correctement au-dessus du contenu, tout en restant sous le header (logo + Menu ×).
  if (drop && drop.parentElement !== document.body) {
    document.body.appendChild(drop);
  }
  if (menuBtn && drop) {
    function setMenu(open) {
      drop.classList.toggle('open', open);
      document.body.classList.toggle('fv-menu-open', open);
      // le header a pu être masqué au scroll (fv-header--hidden) -> le forcer visible à
      // l'ouverture pour que le logo + le bouton de fermeture restent accessibles au-dessus du tiroir
      if (open) hdr.classList.remove('fv-header--hidden');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      /* ⚠️ ON REECRIT LA BALISE, PAS SEULEMENT LE TEXTE.
         Ecrire « Menu × » en texte nu supprimait `.fv-h-menu-mot`, et le
         bouton retombait sur une autre taille de police: le mot retrecissait
         au premier clic. Signale par Jeremie le 15 septembre 2026. La balise
         n'a plus de taille a elle depuis, mais on la conserve pour que le
         balisage soit le meme dans les deux etats.
         ⚠️ L'espace avant le signe est INSECABLE: sans lui, « + » peut passer
         seul a la ligne sur un tres petit ecran. */
      menuBtn.innerHTML = '<span class="fv-h-menu-mot">Menu\u00a0' + (open ? '\u00d7' : '+') + '</span>';
    }
    menuBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      setMenu(!drop.classList.contains('open'));
    });
    // bouton de fermeture répliqué en haut du tiroir (le vrai header est recouvert)
    var closeBtn = drop.querySelector('.fv-md-close');
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); setMenu(false); });
    document.addEventListener('click', function (e) {
      if (drop.classList.contains('open') && !drop.contains(e.target) && e.target !== menuBtn) setMenu(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
  }

  /* ══ LA LIGNE DE RECHERCHE ══
     Le lien « Search » reste un <a href="/search"> : sans JavaScript il emmene
     toujours quelque part. Ici on intercepte le clic pour deplier la deuxieme
     rangee du header. Six polos ne se cherchent pas, ils se parcourent : l'etat
     par defaut de la ligne n'est donc pas un champ vide, c'est une phrase qui
     renvoie au catalogue. */
  var sBtn = document.getElementById('fv-h-search');
  var sRow = document.getElementById('fv-search-row');
  var sIn  = document.getElementById('fv-sr-input');
  var sOut = document.getElementById('fv-sr-out');

  if (sBtn && sRow && sIn && sOut) {
    var sHint = sOut.innerHTML;   // l'etat vide, remis a chaque fermeture
    var sT = null;

    /* Les noms de couleur sont saisis en francais dans l'admin (« Vert Pinede »,
       « Bleu Tyrrhenien »). Un client anglophone tape « green ». On traduit la
       requete, jamais la donnee : l'admin ne se touche pas. */
    var FR = {
      green: 'vert', blue: 'bleu', amber: 'ambre', brown: 'brun', red: 'rouge',
      yellow: 'jaune', black: 'noir', white: 'blanc', grey: 'gris', gray: 'gris',
      pink: 'rose', beige: 'beige', purple: 'violet', cream: 'creme',
      sand: 'sable', navy: 'marine', khaki: 'kaki', burgundy: 'bordeaux',
      ivory: 'ivoire', olive: 'olive'
    };

    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function setSearch(open) {
      sRow.hidden = !open;
      document.body.classList.toggle('fv-search-open', open);
      sBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        hdr.classList.remove('fv-header--hidden');
        /* Le tiroir Menu couvre tout l'ecran sur mobile : les deux ouverts en
           meme temps, on taperait dans un champ qu'on ne voit pas. Un seul
           panneau a la fois. */
        if (drop && drop.classList.contains('open')) {
          drop.classList.remove('open');
          document.body.classList.remove('fv-menu-open');
          if (menuBtn) {
            menuBtn.setAttribute('aria-expanded', 'false');
            menuBtn.innerHTML = '<span class="fv-h-menu-mot">Menu\u00a0+</span>';
          }
        }
        sIn.focus();
      } else {
        clearTimeout(sT);
        sIn.value = '';
        sOut.innerHTML = sHint;
      }
    }

    sBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setSearch(sRow.hidden);
    });
    sRow.addEventListener('click', function (e) { e.stopPropagation(); });
    /* Et la reciproque : le bouton Menu arrete la propagation, donc le
       listener sur document ne verra pas ce clic. On l'ecoute directement. */
    if (menuBtn) {
      menuBtn.addEventListener('click', function () { if (!sRow.hidden) setSearch(false); });
    }

    var sClose = sRow.querySelector('.fv-sr-close');
    if (sClose) sClose.addEventListener('click', function () { setSearch(false); });

    document.addEventListener('click', function () {
      if (!sRow.hidden) setSearch(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sRow.hidden) setSearch(false);
    });

    sIn.addEventListener('input', function () {
      clearTimeout(sT);
      var q = sIn.value.trim();
      if (q.length < 2) { sOut.innerHTML = sHint; return; }
      sT = setTimeout(function () { runSearch(q); }, 180);
    });

    function thumb(src) {
      if (!src) return '';
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
    }

    function runSearch(q) {
      var term = FR[q.toLowerCase()] || q;
      fetch('/search/suggest.json?q=' + encodeURIComponent(term)
            + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (sIn.value.trim() !== q) return;   // reponse en retard, on l'ignore
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (!ps.length) {
            sOut.innerHTML = '<p class="fv-sr-hint">Nothing under &laquo; ' + esc(q)
              + ' &raquo;. The whole club is six polos, '
              + '<a href="/collections/polos">have a look &rarr;</a></p>';
            return;
          }
          /* Aucun prix sur ces lignes : tous les polos sont a 35 $ a l'unite
             alors que la vitrine annonce « from 30 $ ». Un prix ici
             contredirait le bareme au lieu de le servir. */
          var html = '<div class="fv-sr-list">';
          for (var i = 0; i < ps.length; i++) {
            var p = ps[i];
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            html += '<a class="fv-sr-item" href="' + esc(p.url) + '">'
                 + (img ? '<img class="fv-sr-thumb" src="' + esc(thumb(img))
                          + '" alt="" loading="lazy" width="36" height="44">'
                        : '<span class="fv-sr-thumb"></span>')
                 + '<span class="fv-sr-name">' + esc(p.title) + '</span></a>';
          }
          sOut.innerHTML = html + '</div>';
        })
        .catch(function () { sOut.innerHTML = sHint; });
    }
  }

  // sélecteur région/devise dans le tiroir -> soumet au changement
  var mdCountry = document.getElementById('fv-md-country');
  if (mdCountry) {
    mdCountry.addEventListener('change', function () { if (this.form) this.form.submit(); });
  }
}());

  /* ── La hauteur du header, publiee en variable CSS ──
     Posee le 19 aout 2026.

     Le header est `fixed` et se pose PAR-DESSUS le contenu: c'est voulu, la
     photo passe derriere lui et la page respire. Sur un packshot, dont le haut
     n'est que du fond, personne ne le remarque. Sur une photo portee, c'est la
     tete du mannequin qui disparait sous le logo.

     La galerie a donc besoin de savoir de combien elle doit descendre. On ne
     peut pas ecrire ce chiffre en dur: le header ne fait pas la meme hauteur
     selon la largeur de l'ecran. On le mesure, et on le republie a chaque
     redimensionnement. */
  function fvPublierHauteurHeader() {
    var h = document.querySelector('.fv-header');
    if (!h) return;
    var px = Math.round(h.getBoundingClientRect().height);
    if (px > 0) document.documentElement.style.setProperty('--fv-header-h', px + 'px');
  }
  fvPublierHauteurHeader();
  window.addEventListener('resize', fvPublierHauteurHeader);
  window.addEventListener('load', fvPublierHauteurHeader);
}
